import React from 'react';
import cx from 'classnames';
import { IOrganization } from '@dash/organization';

export function getBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function getLogo(organization: IOrganization, classNames: string[] = []) {
  if (!organization) {
    return null;
  }
  const { logo, name } = organization;

  const combinedClassNames = cx('company-avatar', classNames);

  return <img className={combinedClassNames} src={logo} alt={`logo-${name}`} />;
}
